const steps = [
  {
    id: "add",
    attachTo: { element: ".add-new", on: "a" },
    buttons: [
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-secondary",
        text: "Skip",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    classes: "popup-text",
    highlightClass: "tourhighlight",
    scrollTo: false,
    cancelIcon: {
      enabled: true,
    },
    title: "Add New News",
    text: ["By clicking Add new it will redirect page to add news"],
  },
  {
    id: "edit",
    attachTo: { element: ".action-icon.dropdown-toggle", on: "a" },
    buttons: [
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-secondary",
        text: "Skip",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    classes: "popup-text",
    highlightClass: "tourhighlight",
    scrollTo: false,
    cancelIcon: {
      enabled: true,
    },
    title: "Edit / Delete ",
    text: ["By clicking three dots can able to edit / delete the news"],
  },
  {
    id: "filter",
    attachTo: { element: ".ant-table-column-sorters", on: "div" },
    buttons: [
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-secondary",
        text: "Skip",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    classes: "popup-text",
    highlightClass: "tourhighlight",
    scrollTo: false,
    cancelIcon: {
      enabled: true,
    },
    title: "Sort ",
    text: ["By clicking this we can able sort "],
  },
  {
    id: "pagination",
    attachTo: { element: ".ant-pagination", on: "ul" },
    buttons: [
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-secondary",
        text: "End",
        type: "cancel",
      },
    ],
    classes: "popup-text",
    highlightClass: "tourhighlight",
    scrollTo: false,
    cancelIcon: {
      enabled: true,
    },
    title: "Pagination",
    text: ["By clicking this we can able to change the pages"],
  },
];

export default steps;
